// Application configuration
// This file contains application-level configuration values
const getEnvVar = (key, defaultValue = null) => {
  // In production, use window._env_ which is populated by startup.sh
  if (typeof window !== 'undefined' && window._env_) {
    return window._env_[key] || defaultValue;
  }
  
  // In development, fallback to process.env
  if (typeof process.env !== 'undefined' && process.env) {
    return process.env[key] || defaultValue;
  }
  return defaultValue;
};

const projectName = getEnvVar('REACT_APP_CONFIG_GROUP') === 'rms' 
  ? 'Turbo AI' 
  : 'AskCooper AI';

const version = getEnvVar('REACT_APP_CONFIG_GROUP') === 'rms' 
  ? '0.13.1' 
  : '1.15.1';

export const appConfig = {
  version: version,
  projectName: projectName,
};

export default appConfig;